import { useCallback } from "react";

const KEY = "aurora_recently_viewed";
const MAX = 8;

export function useRecentlyViewed() {
  function getIds(): string[] {
    try {
      return JSON.parse(localStorage.getItem(KEY) ?? "[]");
    } catch {
      return [];
    }
  }

  const addId = useCallback((id: string) => {
    const prev = getIds().filter((i) => i !== id);
    const next = [id, ...prev].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  }, []);

  return { getIds, addId };
}
